import { Badge, Box, IconButton, Tooltip } from "@material-ui/core";
import { ClearOutlined, FilterListOutlined } from "@material-ui/icons";
import locale from "@bonliva-crm/locale";
import { ConsultantBulkActions } from "../consultant-bulk-actions/consultant-bulk-actions";
import { useConsultantSearchFilters } from "../../hooks/use-consultant-search-filters";
import { SetUserResponsiblePersonButton } from "./set-user-responsible-person-button";
import { OnlyFavouritesChip } from "../only-favourites-chip";
import { ConsultantSortFilter } from "./consultant-sort-filter";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";

export function ConsultantTableTopBar() {
  const {
    queryInput,
    hasValues,
    columnNameSelectorHook: { toggleAlt, isAlt },
    filterManager: {
      setFilterSliderOpen,
      resetFilters,
      formMethods: { watch }
    }
  } = useConsultantSearchFilters();

  const sortValue = watch("sort");

  return (
    <>
      <ConsultantBulkActions filters={queryInput} sort={sortValue} />

      <Box
        style={{
          marginLeft: "auto",
          display: "flex",
          alignItems: "center",
          gap: 8
        }}
      >
        <ToggleButtonGroup
          style={{ marginRight: 5 }}
          size={"small"}
          value={isAlt}
          exclusive
          onChange={toggleAlt}
        >
          <ToggleButton value={false}>
            <Tooltip
              title={"Standardvy för kolumner. Justera kolumner så som du vill ha dem."}
            >
              <span>Alla</span>
            </Tooltip>
          </ToggleButton>
          <ToggleButton value={true}>
            <Tooltip title={"Vy för kvalitetssäkring. Välj de som är relevanta för dig."}>
              <span>Kvk</span>
            </Tooltip>
          </ToggleButton>
        </ToggleButtonGroup>

        <SetUserResponsiblePersonButton />

        <OnlyFavouritesChip />

        <Tooltip title={locale.AllFilters}>
          <IconButton onClick={() => setFilterSliderOpen(true)}>
            <Badge color="primary" variant="dot" invisible={!hasValues}>
              <FilterListOutlined />
            </Badge>
          </IconButton>
        </Tooltip>

        <Tooltip title={locale.resetFilters}>
          <IconButton onClick={resetFilters}>
            <ClearOutlined />
          </IconButton>
        </Tooltip>

        <ConsultantSortFilter />
      </Box>
    </>
  );
}
